module.exports = __webpack_public_path__ + "img/img-garantie.1c6f993e.gif";